function track(event = '', properties = {}, ...rest) {
  const amendedProperties = Object.assign({ platform: 'web', product: 'glm' }, properties);

  if (window.analytics) {
    window.analytics.track(event, amendedProperties, ...rest);
  }
}

function trackDecorator(event, properties = {}, ...rest) {
  return function decorator(target, name, descriptor) {
    const originalFn = descriptor.value;

    function decoratedFn(...args) {
      track(event, properties, ...rest);
      originalFn.apply(this, args);
    }

    Object.assign(descriptor, { value: decoratedFn });
    return descriptor;
  };
}

function getChangedProps(newProps, originalProps) {
  const updatedProps = {};
  const keys = Object.keys(newProps);

  if (originalProps) {
    keys.forEach(key => {
      if (newProps[key] !== originalProps[key]) {
        updatedProps[key] = true;
      }
    });
  } else {
    keys.forEach(key => {
      if (!!newProps[key] || newProps[key] === false) {
        updatedProps[key] = true;
      }
    });
  }

  return updatedProps;
}

export { track, trackDecorator, getChangedProps };
